export enum FormTypes {
  Text = "text",
  SSN = "ssn",
  Date = "date",
  Phone = "phone",
  Email = "email",
  EntityEmail = "entityEmail",
  Address = "address",
  TaxId = "taxId",
  AccountNumber = "accountNumber",
  advisorId = "advisorId",
  BankABA = "bankABA",
  AccountTitle = "accountTitle",
  EntityType = "EntityType",
  EntityCode = "EntityCode",
  Alphanumeric = "alphanumeric",
  PrimaryColor = "primaryColor",
  SecondaryColor = "secondaryColor",
  ZipCode = "ZipCode",
}
